import SingleTeamResult from "./SingleTeamResult";

export default SingleTeamResult;
